import React from 'react';
import PropTypes from 'prop-types';

import ZoomButtons from '../ZoomButtons';

const ControlButtons = ({ setZoom }) => {
  return (
    // The column stacks above the Mapbox controls, so only its buttons may
    // take clicks; the margins around them let clicks through to the locate
    // and search controls.
    <div className="absolute flex flex-col z-10 right-0 bottom-0 pointer-events-none">
      <ZoomButtons setZoom={setZoom} />
    </div>
  );
};

ControlButtons.propTypes = {
  setZoom: PropTypes.func.isRequired
};

export default ControlButtons;
